/**
 * External Dependencies
 */

import './components/carousel';
import './components/parallax';
import './components/interactive-list';
import './components/nav';
import './components/modal';
import './components/amenities-map';
import './components/nearby-locations-map';
import './components/accordion';
import './components/showhomes';
import './components/news';
import './components/load-more';
import './components/village-centre';
import LazyLoad from "vanilla-lazyload";

var myLazyLoad = new LazyLoad();
// After your content has changed...
//myLazyLoad.update();
/* asdf */

//caching
const terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';

addEventListener(terminationEvent, (event) => {
  // Note: if the browser is able to cache the page, `event.persisted`
  // is `true`, and the state is frozen rather than terminated.
}, {capture: true});